import React, {useState, useEffect, useCallback} from 'react';
import { useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';
import questionsYN from "../../../JSONS/ev-survey-A.json"
import questionsMC from "../../../JSONS/ev-survey-B.json"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Chart as ChartJS, LineElement, PointElement, Tooltip, Legend, RadialLinearScale, Filler, ArcElement } from 'chart.js'
import { PolarArea } from 'react-chartjs-2'

ChartJS.register(
  LineElement, 
  PointElement, 
  Tooltip, 
  Legend, 
  RadialLinearScale,
  Filler,
  ArcElement
)

const HabitsCalculator = () => {

    const Navigate = useNavigate();
    const MySwal = withReactContent(Swal)

    const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
    const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;

    const [SurveyPage, setSurveyPage] = useState(0);

    // Page 1 variables
    const [YNAnswers, setYNAnswers] = useState([-1,-1,-1,-1,-1,-1,-1,-1,-1,-1])
    const [YNAnswersCat, setYNAnswersCat] = useState(["","","","","","","","","",""])
    const [YNIncomplete, setYNIncomplete] = useState(false);
    const [YNPoints, setYNPoints] = useState([0,0,0,0,0]);

    // Page 2 variables
    const [MCAnswers, setMCAnswers] = useState([0,0,0,0,0,0,0,0,0,0,0])
    const [MCMax, setMCMax] = useState([false,false,false,false,false,false,false,false,false,false,false])

    // Submit variables
    const [TotalPoints, setTotalPoints] = useState([0,0,0,0,0])
    const [Sendoff, setSendoff] = useState(false)
    const [Calculated, setCalculated] = useState(false)

    const gender = decodedToken && decodedToken.gender === 1 ? "M" : decodedToken.gender === 2 ? "F" : ""

    const habitCats = ['Bienestar','Movimiento','Nutrición','Recuperación','Consumo']

    const GraphBG = TotalPoints.map((a) => a < 4 ? "rgba(255, 0, 0, .3)" : a < 8 ? "rgba(255, 205, 41, .3)" : "rgba(139, 197, 63, .3)")

    const GraphDataPre= {
        labels: habitCats,
        datasets: [{
            label: " Puntaje",
            circular: false,
            data: [10,10,10,10,10],
            fill: true,
            borderColor: '#CCCCFF',
            pointBackgroundColor: '#6633FF',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(54, 162, 235)',
            backgroundColor: ["rgba(139, 197, 63, .3)","rgba(139, 197, 63, .3)","rgba(139, 197, 63, .3)","rgba(139, 197, 63, .3)","rgba(139, 197, 63, .3)"],
            borderWidth: 1
        }],
    }

    const GraphData= {
        labels: habitCats,
        datasets: [{
            label: " Puntaje",
            circular: false,
            data: TotalPoints,
            fill: true,
            borderColor: '#CCCCFF',
            pointBackgroundColor: '#6633FF',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(54, 162, 235)',
            backgroundColor: GraphBG,
            borderWidth: 1
        }],
    }
  
    const GraphOptions = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
            legend: {
            display: false,
            },
        },
        scales: {
            r: {
                angleLines: {
                    display: true
                },
                ticks: {
                    display: false
                },
                pointLabels: {
                display: true,
                centerPointLabels: true,
                font: {
                    size: 14
                },
                padding: -20
                },
                grid: {
                circular: false
                }
            },
        },
        scale: {
            r: {
            min: 0, // MIN
            max: 10, // MAX
            beginAtZero: true,
            display: false,
            angleLines: {
                display: true,
                color: 'red'
            }
    
            },
            ticks: {
                beginAtZero: true,
                max: 10,
                min: 0,
                stepSize: 1
            },
            pointLabels: {
            display: true,
            font: {size: 20}
            },
            angleLines: {
            color: 'red'
            }
        },
    }

    function handleYNs(number, question, ans) {
        let points = YNPoints
        let allanswers = YNAnswers
        let saveanswers = YNAnswersCat
        let tmp1 = document.getElementById(question+'Y')
        let tmp2 = document.getElementById(question+'N')
        let actualIndex = questionsYN[question].cat_num
    
        if(ans === 'Y' && YNAnswersCat[number] !== "SI") {
            if(tmp2.className.includes("DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile")) {
              points[actualIndex] -= questionsYN[question].answers[1].points
            }
            allanswers[number] = questionsYN[question].answers[0].points
            saveanswers[number] = "SI"
            points[actualIndex] += questionsYN[question].answers[0].points
        } else if(ans === 'N' && YNAnswersCat[number] !== "NO"){
            if(tmp1.className.includes("DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile")) {
              points[actualIndex] -= questionsYN[question].answers[0].points
            }
            allanswers[number] = questionsYN[question].answers[1].points
            saveanswers[number] = "NO"
            points[actualIndex] += questionsYN[question].answers[1].points
        }
    
        setYNAnswers([...allanswers])
        setYNAnswersCat([...saveanswers])
        setYNPoints([...points])
    }
    
    function YNVerify(first) {
        let CurrentQs = first ? YNAnswers.slice(0,5) : YNAnswers.slice(5,10)
        let plus = first ? 0 : 5
        if(CurrentQs.includes(-1)) {
          if(YNIncomplete) return
          let Qs = Object.keys(questionsYN)
          for(let i=0; i<CurrentQs.length; i++) {
            if(YNAnswers[i+plus] === -1) {
              let tmp1 = document.getElementById(Qs[i+plus]+'Y')
              let tmp2 = document.getElementById(Qs[i+plus]+'N')
              tmp1.className += " UserWelcomeBlockYNTileIncomplete"
              tmp2.className += " UserWelcomeBlockYNTileIncomplete"
            }
          }
          setYNIncomplete(true)
        } else {
          //setYNPoints(YNAnswers.reduce((partialSum, a) => partialSum + a, 0))
          if(first) {
            setSurveyPage(2)
          } else {
            setSurveyPage(3)
          }
          setYNIncomplete(false)
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
        }
    }

    function handleMCs(number, question, ans) {
        let allanswers = MCAnswers
        document.getElementById("rangeValue"+question).innerText = ans;
        allanswers[number] = parseInt(ans)
        setMCAnswers([...allanswers])
        let maximums = MCMax
        if(questionsMC[question].ranges[1] === parseInt(ans)) {
            maximums[number] = true
        } else {
            maximums[number] = false
        }
        setMCMax([...maximums])
    }
    
    function MCPointsCount() {
        let allanswers = MCAnswers
        let points = [0,0,0,0,0]
        for(let i = 0; i<allanswers.length; i++) {
    
          let tmpAns = questionsMC[Object.keys(questionsMC)[i]]
          if(tmpAns.depends) {
            let gends = tmpAns.answers.filter((a) => a.gender === gender)
            for(let j = 0; j<gends.length; j++) {
              if(allanswers[i] >= gends[j].minValue && allanswers[i] < gends[j].maxValue) {
                points[tmpAns["cat_num"]] += gends[j].points
                //console.log(gends[j].points, j)
              }
            }
            //console.log(gends)
          } else {
            for(let j = 0; j<tmpAns.answers.length; j++) {
              if(allanswers[i] >= tmpAns.answers[j].minValue && allanswers[i] < tmpAns.answers[j].maxValue) {
                points[tmpAns["cat_num"]] += tmpAns.answers[j].points
                //console.log(tmpAns.answers[j].points, j)
              }
            }
          }
        }

        let sum = TotalPoints;
        for(let i=0; i<sum.length; ++i) {
            sum[i] = YNPoints[i] + points[i];
        }
        setTotalPoints([...sum])
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
        setSendoff(true)
    }

    const saveAllAnswers = useCallback( async() => {

        MySwal.fire({
            position: "center",
            html: 
            <div className="FullAlertWidth1">
                <div className="FullAlertUpTitle">Calculando...</div>
                <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
            </div>,
            color: "#340066",
            customClass: 'swal-wide',
            showConfirmButton: false,
            width: "100%",
        })
    
        let params = {
            rut: decodedToken.rut,
            YN: YNAnswersCat,
            MC: MCAnswers,
            points: TotalPoints
        };

        let params2 = {
            rut: decodedToken.rut,
            sex: gender,
            habits: TotalPoints.reduce((partialSum, a) => partialSum + a, 0)
        }

        let requestOptions = {
            method: 'POST',
            redirect: 'follow',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(params)
        };

        let requestOptions2 = {
            method: 'POST',
            redirect: 'follow',
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify(params2)
        };

        try{
          
            const resp = await fetch("https://ymc-doc-api.azurewebsites.net/userhabits", requestOptions)
            if (resp.status !== 200){
                MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error al subir los datos",
                    text: "Por favor inténtelo más tarde",
                    showConfirmButton: true
                });
                return false;
            }

            const resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/addnewparamresults", requestOptions2)
            if (resp2.status !== 200){
                MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
                });
                return false;
            }
            
            document.body.scrollTop = 0; 
            document.documentElement.scrollTop = 0;
        
            window.localStorage.setItem("HabitsCalculated",true)
            setSurveyPage(5);
            setCalculated(true)
            MySwal.close()
        }
        catch(error){
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false
        }
    },[MCAnswers,MySwal,TotalPoints,YNAnswersCat,decodedToken,gender])

    useEffect(() => {
        if(Sendoff) {
            saveAllAnswers()
            setSendoff(false)
        }
    }, [Sendoff, saveAllAnswers]);

    function toggleAdditional(id) {
        let tmp = document.getElementById(id)
        if(tmp.className.includes("UserWelcomeBlockPage1SpecificsHidden")) {
          tmp.className = tmp.className.replace(" UserWelcomeBlockPage1SpecificsHidden", "");
        } else {
          tmp.className += " UserWelcomeBlockPage1SpecificsHidden"
        }
    }
    

    return (
        <div className='UserProfileFull'>
            <div className='UserProfileInnerDiv'>
                <div className='UserProfileInnerDivCalculatorWhiteBlock2'>
                    {Calculated ?
                    <div className="HeartAgeCalculatorResultsTitleDiv UserProfileHeartAgeCalculatorWhiteBlockTitleDiv" style={{backgroundColor:"#CCCCFF"}}>
                        <div className="HeartAgeCalculatorRightSideTitleFlex">
                        <img alt="" className="HeartAgeCalculatorRightSideTitleIcon" src="https://static.yomecontrolo.cl/public/icons/HealthCalculatorPurpleLogo.png"/>
                        <div className="HeartAgeCalculatorRightSideTitleInnerDiv">
                            <div className="HeartAgeCalculatorRightSideUpTitle">Calculadora de Salud</div>
                            <div className="HeartAgeCalculatorRightSideTitle">Resultados</div>
                            <div className="HeartAgeCalculatorRightSideUpTitle">Hábitos de Salud</div>
                        </div>
                        </div>
                        <img alt="" className="HeartAgeCalculatorResultsTitleYMCLogo" src="https://static.yomecontrolo.cl/public/icons/YMC_Logo_NoText.png"/>
                    </div>
                    : null
}
                    {SurveyPage === 0 ?
                    <>
                    <div className='UserWelcomeBlockPageWideFlex'>
                        <div className='UserWelcomeBlockPageWideSideL'>
                            <div className='UserWelcomeBlockPage1TitleFlex'>
                                <div className='UserWelcomeBlockPage1Title'>Estilo de Vida&ensp;</div>
                                <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("Added1")}>?</div>
                            </div>
                            <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">El cuestionario médico del estilo de vida se ha diseñado como una herramienta de detección que evalúa los hábitos diarios que pueden afectar a la salud.
                            <br/>En esta herramienta, cada categoría representa un comportamiento que puede modificarse. Éstas están plenamente documentadas y relacionadas con investigaciones específicas que han demostrado tener algún beneficio para la salud y el bienestar.
                            <br/>¿Estás listo para mejorar tu estilo de vida?
                            </div>
                            <img alt="" className={SurveyPage === 0 ? 'UserWelcomeBlockPage1TitleFoodImage' : 'UserWelcomeBlockPage1TitleFoodImage2'} src={SurveyPage === 0 ? "https://static.yomecontrolo.cl/public/img/calculator/HabitsSurveyImage.png" : "https://static.yomecontrolo.cl/public/img/calculator/HabitsSurveyImage2.png"} />
                            <div className='UserProfileInnerDivCalculatorWhiteBlockCompletionText'><span className='UserProfileInnerDivCalculatorWhiteBlockCompletionBigNumber'>1</span> de 5</div>
                            <div className='UserWelcomeIntroPageCounterLineStart'>
                                <div className='UserWelcomeIntroPageCounterLinePurple'></div>
                                <div className='UserWelcomeIntroPageCounterLine'></div>
                                <div className='UserWelcomeIntroPageCounterLine'></div>
                                <div className='UserWelcomeIntroPageCounterLine'></div>
                                <div className='UserWelcomeIntroPageCounterLine'></div>
                            </div>
                        </div>
                        <div className='UserWelcomeBlockPageWideSideR' style={{marginBlock:"auto"}}>
                            <h4 className='UserWelcomeBlockResultsCategoriesTitle'>Categorías de Evaluación</h4>
                            <div className='UserWelcomePretestGraph' style={{marginBlockEnd:"15px"}}>
                                <PolarArea data={GraphDataPre} options={GraphOptions} ></PolarArea>
                            </div>
                        </div>
                    </div>
                    <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton"  onClick={() => {setSurveyPage(1); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}} style={{marginInline:"auto"}}>
                        <div className="GeneralPurpleButtonText">Comenzar</div>
                        <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                    </div>
                    </>
                    : SurveyPage === 1 ?
                    <>
                        <div className='UserWelcomeBlockPageWideFlex'>
                            <div className='UserWelcomeBlockPageWideSideL'>
                                <div className='UserWelcomeBlockPage1TitleFlex'>
                                    <div className='UserWelcomeBlockPage1Title'>Estilo de Vida&ensp;</div>
                                    <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("Added1")}>?</div>
                                </div>
                                <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">La encuesta de hábitos tiene como objetivo ayudarte a reflexionar sobre tus prácticas diarias y cómo estas impactan en tu bienestar general. Evaluamos cinco categorías clave porque representan pilares esenciales para mantener un estilo de vida saludable y equilibrado. No buscamos juzgar tus hábitos, sino proporcionarte una visión clara de tus puntos fuertes y las áreas donde puedes mejorar.</div>
                                <img alt="" className={SurveyPage === 0 ? 'UserWelcomeBlockPage1TitleFoodImage' : 'UserWelcomeBlockPage1TitleFoodImage2'} src={SurveyPage === 0 ? "https://static.yomecontrolo.cl/public/img/calculator/HabitsSurveyImage.png" : "https://static.yomecontrolo.cl/public/img/calculator/HabitsSurveyImage2.png"} />
                                <div className='UserProfileInnerDivCalculatorWhiteBlockCompletionText'><span className='UserProfileInnerDivCalculatorWhiteBlockCompletionBigNumber'>2</span> de 5</div>
                                <div className='UserWelcomeIntroPageCounterLineStart'>
                                    <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                                    <div className='UserWelcomeIntroPageCounterLinePurple'></div>
                                    <div className='UserWelcomeIntroPageCounterLine'></div>
                                    <div className='UserWelcomeIntroPageCounterLine'></div>
                                    <div className='UserWelcomeIntroPageCounterLine'></div>
                                </div>
                            </div>
                            <div className='UserWelcomeBlockPageWideSideR'>
                                <div className='UserWelcomeBlockPage1Subtitle2'>Para cada ítem, piensa en los <span className='UserWelcomeBlockPage1Subtitle2Highlight'>últimos siete días</span> y responde 'Sí' o 'No' si tú...</div>
                                {[...Object.keys(questionsYN).keys()].slice(0,5).map((Question) => (
                                <div className='UserWelcomeBlockYNQuestionContainer' key={Object.keys(questionsYN)[Question]+Question} >
                                    <div className='UserWelcomeBlockYNQuestion' style={{color: YNAnswersCat[Question].length === 0 && YNIncomplete ? "red" : YNAnswersCat[Question].length !== 0 ? "#8BC53F" : null}}>{Question+1}- {questionsYN[Object.keys(questionsYN)[Question]].question}</div>
                                    <div className='UserWelcomeBlockYNTileFlex'>
                                    <div className={YNAnswersCat[Question] === "SI" ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile UserWelcomeBlockYNTile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile UserWelcomeBlockYNTile"} 
                                        id={Object.keys(questionsYN)[Question]+'Y'} 
                                        style={{borderBottom: YNAnswersCat[Question].length === 0 && YNIncomplete ? "red solid 1px" : YNAnswersCat[Question].length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: YNAnswersCat[Question] === "SÍ" ? "#F2F2FF" : YNAnswersCat[Question].length === 0 && YNIncomplete === "invalid" ? "#FFFAEA" : "white"}}
                                        onClick={() => handleYNs(Question, Object.keys(questionsYN)[Question], 'Y')}>{questionsYN[Object.keys(questionsYN)[Question]].answers[0].text}</div>
                                    <div className={YNAnswersCat[Question] === "NO" ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile UserWelcomeBlockYNTile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile UserWelcomeBlockYNTile"} 
                                        id={Object.keys(questionsYN)[Question]+'N'}
                                        style={{borderBottom: YNAnswersCat[Question].length === 0 && YNIncomplete ? "red solid 1px" : YNAnswersCat[Question].length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: YNAnswersCat[Question] === "NO" ? "#F2F2FF" : YNAnswersCat[Question].length === 0 && YNIncomplete === "invalid" ? "#FFFAEA" : "white"}}
                                        onClick={() => handleYNs(Question, Object.keys(questionsYN)[Question], 'N')}>{questionsYN[Object.keys(questionsYN)[Question]].answers[1].text}</div>
                                    </div>
                                </div>
                                ))}
                            </div>
                        </div>
                        <div className='UserWelcomeBlockYNQuestionAlert' id="YNVerif" style={{ color: "red", fontWeight: "500" }}>{YNIncomplete ? "Hay al menos una pregunta sin responder, por favor revise sus respuestas." : null}</div>
                        <div className='UserWelcomeBlockNextButtonFlex'>
                            <div className="GeneralWhiteButtonFlex UserWelcomeBlockPageButton1" onClick={() => {setSurveyPage(0); setYNIncomplete(false); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowPurple' style={{rotate:"180deg"}}></i></div>
                                <div className="GeneralWhiteButtonText GeneralWhiteButtonTextPreviousText">Anterior</div>
                            </div>
                            <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton" onClick={() => YNVerify(true)}>
                                <div className="GeneralPurpleButtonText">Siguiente</div>
                                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                            </div>
                        </div>
                    </>
                    : SurveyPage === 2 ?
                    <>
                        <div className='UserWelcomeBlockPageWideFlex'>
                            <div className='UserWelcomeBlockPageWideSideL'>
                                <div className='UserWelcomeBlockPage1TitleFlex'>
                                    <div className='UserWelcomeBlockPage1Title'>Estilo de Vida&ensp;</div>
                                    <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("Added1")}>?</div>
                                </div>
                                <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">La encuesta de hábitos tiene como objetivo ayudarte a reflexionar sobre tus prácticas diarias y cómo estas impactan en tu bienestar general. Evaluamos cinco categorías clave porque representan pilares esenciales para mantener un estilo de vida saludable y equilibrado. No buscamos juzgar tus hábitos, sino proporcionarte una visión clara de tus puntos fuertes y las áreas donde puedes mejorar.</div>
                                <img alt="" className={SurveyPage === 0 ? 'UserWelcomeBlockPage1TitleFoodImage' : 'UserWelcomeBlockPage1TitleFoodImage2'} src={SurveyPage === 0 ? "https://static.yomecontrolo.cl/public/img/calculator/HabitsSurveyImage.png" : "https://static.yomecontrolo.cl/public/img/calculator/HabitsSurveyImage2.png"} />
                                <div className='UserProfileInnerDivCalculatorWhiteBlockCompletionText'><span className='UserProfileInnerDivCalculatorWhiteBlockCompletionBigNumber'>3</span> de 5</div>
                                <div className='UserWelcomeIntroPageCounterLineStart'>
                                    <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                                    <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                                    <div className='UserWelcomeIntroPageCounterLinePurple'></div>
                                    <div className='UserWelcomeIntroPageCounterLine'></div>
                                    <div className='UserWelcomeIntroPageCounterLine'></div>
                                </div>
                            </div>
                            <div className='UserWelcomeBlockPageWideSideR'>
                                <div className='UserWelcomeBlockPage1Subtitle2'>Para cada ítem, piensa en los <span className='UserWelcomeBlockPage1Subtitle2Highlight'>últimos siete días</span> y responde 'Sí' o 'No' si tú...</div>
                                {[...Object.keys(questionsYN).keys()].slice(5,10).map((Question) => (
                                <div className='UserWelcomeBlockYNQuestionContainer' key={Object.keys(questionsYN)[Question]+Question} >
                                    <div className='UserWelcomeBlockYNQuestion' style={{color: YNAnswersCat[Question].length === 0 && YNIncomplete ? "red" : YNAnswersCat[Question].length !== 0 ? "#8BC53F" : null}}>{Question+1}- {questionsYN[Object.keys(questionsYN)[Question]].question}</div>
                                    <div className='UserWelcomeBlockYNTileFlex'>
                                    <div className={YNAnswersCat[Question] === "SI" ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile UserWelcomeBlockYNTile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile UserWelcomeBlockYNTile"} 
                                        id={Object.keys(questionsYN)[Question]+'Y'} 
                                        style={{borderBottom: YNAnswersCat[Question].length === 0 && YNIncomplete ? "red solid 1px" : YNAnswersCat[Question].length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: YNAnswersCat[Question] === "SÍ" ? "#F2F2FF" : YNAnswersCat[Question].length === 0 && YNIncomplete === "invalid" ? "#FFFAEA" : "white"}}
                                        onClick={() => handleYNs(Question, Object.keys(questionsYN)[Question], 'Y')}>{questionsYN[Object.keys(questionsYN)[Question]].answers[0].text}</div>
                                    <div className={YNAnswersCat[Question] === "NO" ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile UserWelcomeBlockYNTile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile UserWelcomeBlockYNTile"} 
                                        id={Object.keys(questionsYN)[Question]+'N'}
                                        style={{borderBottom: YNAnswersCat[Question].length === 0 && YNIncomplete ? "red solid 1px" : YNAnswersCat[Question].length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: YNAnswersCat[Question] === "NO" ? "#F2F2FF" : YNAnswersCat[Question].length === 0 && YNIncomplete === "invalid" ? "#FFFAEA" : "white"}}
                                        onClick={() => handleYNs(Question, Object.keys(questionsYN)[Question], 'N')}>{questionsYN[Object.keys(questionsYN)[Question]].answers[1].text}</div>
                                    </div> 
                                </div>
                                ))}
                            </div>
                        </div>
                        <div className='UserWelcomeBlockYNQuestionAlert' id="YNVerif" style={{ color: "red", fontWeight: "500" }}>{YNIncomplete ? "Hay al menos una pregunta sin responder, por favor revise sus respuestas." : null}</div>
                        <div className='UserWelcomeBlockNextButtonFlex'>
                            <div className="GeneralWhiteButtonFlex UserWelcomeBlockPageButton1" onClick={() => {setSurveyPage(1); setYNIncomplete(false); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowPurple' style={{rotate:"180deg"}}></i></div>
                                <div className="GeneralWhiteButtonText GeneralWhiteButtonTextPreviousText">Anterior</div>
                            </div>
                            <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton" onClick={() => YNVerify(false)}>
                                <div className="GeneralPurpleButtonText">Siguiente</div>
                                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                            </div>
                        </div>
                    </>
                    : SurveyPage === 3 ?
                    <>
                        <div className='UserWelcomeBlockPageWideFlex'>
                            <div className='UserWelcomeBlockPageWideSideL'>
                                <div className='UserWelcomeBlockPage1TitleFlex'>
                                    <div className='UserWelcomeBlockPage1Title'>Estilo de Vida&ensp;</div>
                                    <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("Added1")}>?</div>
                                </div>
                                <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">La encuesta de hábitos tiene como objetivo ayudarte a reflexionar sobre tus prácticas diarias y cómo estas impactan en tu bienestar general. Evaluamos cinco categorías clave porque representan pilares esenciales para mantener un estilo de vida saludable y equilibrado. No buscamos juzgar tus hábitos, sino proporcionarte una visión clara de tus puntos fuertes y las áreas donde puedes mejorar.</div>
                                <img alt="" className={SurveyPage === 0 ? 'UserWelcomeBlockPage1TitleFoodImage' : 'UserWelcomeBlockPage1TitleFoodImage2'} src={SurveyPage === 0 ? "https://static.yomecontrolo.cl/public/img/calculator/HabitsSurveyImage.png" : "https://static.yomecontrolo.cl/public/img/calculator/HabitsSurveyImage2.png"} />
                                <div className='UserProfileInnerDivCalculatorWhiteBlockCompletionText'><span className='UserProfileInnerDivCalculatorWhiteBlockCompletionBigNumber'>4</span> de 5</div>
                                <div className='UserWelcomeIntroPageCounterLineStart'>
                                    <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                                    <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                                    <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                                    <div className='UserWelcomeIntroPageCounterLinePurple'></div>
                                    <div className='UserWelcomeIntroPageCounterLine'></div>
                                </div>
                            </div>
                            <div className='UserWelcomeBlockPageWideSideR'>
                                <div className='UserWelcomeBlockPage1Subtitle2'>Para cada ítem, piensa en los <span className='UserWelcomeBlockPage1Subtitle2Highlight'>últimos siete días</span> y utiliza los sliders para responder</div>
                                {[...Object.keys(questionsMC).keys()].slice(0,5).map((Question) => (
                                <div className='UserWelcomeBlockRangeQuestionContainer' key={"rangeDiv"+Question}>
                                    <div className='UserWelcomeBlockRangeQuestion'>{Question+1}- {questionsMC[Object.keys(questionsMC)[Question]].question}</div>
                                    <div className='UserWelcomeBlockRangeTileFlex'>
                                    <input id={"rangeInput"+Question} 
                                        type="range" 
                                        min={questionsMC[Object.keys(questionsMC)[Question]].ranges[0]} 
                                        max={questionsMC[Object.keys(questionsMC)[Question]].ranges[1]} 
                                        defaultValue={MCAnswers[Question]} className='UserWelcomeBlockRangeInputTile' 
                                        onInput={(e) => handleMCs(Question, Object.keys(questionsMC)[Question], e.target.value) } />
                                    <div id={"rangeValue"+Object.keys(questionsMC)[Question]} className='UserWelcomeBlockRangeTile'>{MCMax[Question] ? MCAnswers[Question]+"+" : MCAnswers[Question]}</div> 
                                    </div>
                                </div>
                                ))}
                            </div>
                        </div>
                        <div className='UserWelcomeBlockNextButtonFlex'>
                            <div className="GeneralWhiteButtonFlex UserWelcomeBlockPageButton1" onClick={() => {setSurveyPage(2); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowPurple' style={{rotate:"180deg"}}></i></div>
                                <div className="GeneralWhiteButtonText">Anterior</div>
                            </div>
                            <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton" onClick={() => { setSurveyPage(4); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                                <div className="GeneralPurpleButtonText">Siguiente</div>
                                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                            </div>
                        </div>
                    </>
                    : SurveyPage === 4 ?
                    <>
                        <div className='UserWelcomeBlockPageWideFlex'>
                            <div className='UserWelcomeBlockPageWideSideL'>
                                <div className='UserWelcomeBlockPage1TitleFlex'>
                                    <div className='UserWelcomeBlockPage1Title'>Estilo de Vida&ensp;</div>
                                    <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("Added1")}>?</div>
                                </div>
                                <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">La encuesta de hábitos tiene como objetivo ayudarte a reflexionar sobre tus prácticas diarias y cómo estas impactan en tu bienestar general. Evaluamos cinco categorías clave porque representan pilares esenciales para mantener un estilo de vida saludable y equilibrado. No buscamos juzgar tus hábitos, sino proporcionarte una visión clara de tus puntos fuertes y las áreas donde puedes mejorar.</div>
                                <img alt="" className={SurveyPage === 0 ? 'UserWelcomeBlockPage1TitleFoodImage' : 'UserWelcomeBlockPage1TitleFoodImage2'} src={SurveyPage === 0 ? "https://static.yomecontrolo.cl/public/img/calculator/HabitsSurveyImage.png" : "https://static.yomecontrolo.cl/public/img/calculator/HabitsSurveyImage2.png"} />
                                <div className='UserProfileInnerDivCalculatorWhiteBlockCompletionText'><span className='UserProfileInnerDivCalculatorWhiteBlockCompletionBigNumber'>5</span> de 5</div>
                                <div className='UserWelcomeIntroPageCounterLineStart'>
                                    <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                                    <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                                    <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                                    <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                                    <div className='UserWelcomeIntroPageCounterLinePurple'></div>
                                </div>
                            </div>
                            <div className='UserWelcomeBlockPageWideSideR'>
                                <div className='UserWelcomeBlockPage1Subtitle2'>Para cada ítem, piensa en los <span className='UserWelcomeBlockPage1Subtitle2Highlight'>últimos siete días</span> y utiliza los sliders para responder</div>
                                {[...Object.keys(questionsMC).keys()].slice(5,11).map((Question) => (
                                <div className='UserWelcomeBlockRangeQuestionContainer' key={"rangeDiv"+Question}>
                                    <div className='UserWelcomeBlockRangeQuestion'>{Question+1}- {questionsMC[Object.keys(questionsMC)[Question]].question}</div>
                                    <div className='UserWelcomeBlockRangeTileFlex'>
                                    <input id={"rangeInput"+Question} 
                                        type="range" 
                                        min={questionsMC[Object.keys(questionsMC)[Question]].ranges[0]} 
                                        max={questionsMC[Object.keys(questionsMC)[Question]].ranges[1]} 
                                        defaultValue={MCAnswers[Question]} className='UserWelcomeBlockRangeInputTile' 
                                        onInput={(e) => handleMCs(Question, Object.keys(questionsMC)[Question], e.target.value)} />
                                    <div id={"rangeValue"+Object.keys(questionsMC)[Question]} className='UserWelcomeBlockRangeTile'>{MCMax[Question] ? MCAnswers[Question]+"+" : MCAnswers[Question]}</div> 
                                    </div>
                                </div>
                                ))}
                            </div>
                        </div>
                        <div className='UserWelcomeBlockNextButtonFlex'>
                            <div className="GeneralWhiteButtonFlex UserWelcomeBlockPageButton1" onClick={() => {setSurveyPage(3); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowPurple' style={{rotate:"180deg"}}></i></div>
                                <div className="GeneralWhiteButtonText">Anterior</div>
                            </div>
                            <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton" onClick={() => { MCPointsCount();}}>
                                <div className="GeneralPurpleButtonText">Calcular</div>
                                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                            </div>
                        </div>
                    </>
                    : 
                    <>
                        <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedWideFlex'>
                            {(TotalPoints.reduce((partialSum, a) => partialSum + a, 0)*2) > 75 ?
                                <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedTop' style={{backgroundColor:"#8BC53F"}}>
                                    <h5 className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedTitle' style={{color: "white"}}>
                                        <span style={{fontWeight:"700"}}>Embajador de Hábitos Saludables</span>
                                    </h5>
                                    <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedUpTitle' style={{color: "white"}}>{TotalPoints.reduce((partialSum, a) => partialSum + a, 0)} de 50 puntos</div>
                                </div>
                            : (TotalPoints.reduce((partialSum, a) => partialSum + a, 0)*2) > 50 ?
                                <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedTop' style={{backgroundColor:"#FFCD29"}}>
                                    <h5 className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedTitle'>
                                        <span style={{fontWeight:"700"}}>En Camino:<br/>
                                        Constructor de Hábitos</span>
                                    </h5>
                                    <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedUpTitle'>{TotalPoints.reduce((partialSum, a) => partialSum + a, 0)} de 50 puntos</div>
                                </div>
                                :
                                <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedTop' style={{backgroundColor:"#FF4F53"}}>
                                    <h5 className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedTitle' style={{color: "white"}}>
                                        <span style={{fontWeight:"700"}}>Zona Crítica:<br/>
                                        Alerta de Hábitos</span>
                                    </h5>
                                    <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedUpTitle' style={{color: "white"}}>{TotalPoints.reduce((partialSum, a) => partialSum + a, 0)} de 50 puntos</div>
                                </div>
    }
                            <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedFlex'>
                                <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedLeft'>
                                    <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedLeftImage' src="https://static.yomecontrolo.cl/public/img/calculator/HabitsSurveyImage.png" />
                                </div>
                                <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedRight' style={{padding: "5px"}}>
                                    {[...Array(TotalPoints.length).keys()].map((ind) => (
                                        <div key={habitCats[ind]} className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedRightHabitBox' style={{backgroundColor: TotalPoints[ind] > 7 ? "#8BC53F" : TotalPoints[ind] > 4 ? "#FFCD29" : "#FF4F53", color: TotalPoints[ind] <= 4 ? "white" : null}} >
                                            {habitCats[ind]} | {TotalPoints[ind]} de 10 puntos</div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/calculator/RiskMeterHorizontalHabits.svg')",backgroundPosition: 'center',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                            {TotalPoints.reduce((partialSum, a) => partialSum + a, 0)*2 > 75 ? 
                            <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src="https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_LowRiskFace.png" style={{ left: TotalPoints.reduce((partialSum, a) => partialSum + a, 0)*2-12.5 + "%" }} />
                            : TotalPoints.reduce((partialSum, a) => partialSum + a, 0)*2 > 50 ? 
                            <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src="https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_MidRiskFace.png" style={{ left: TotalPoints.reduce((partialSum, a) => partialSum + a, 0)*2-12.5 + "%" }} />
                            : 
                            <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src="https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_HighRiskFace.png" style={{ left: TotalPoints.reduce((partialSum, a) => partialSum + a, 0)*2-12.5 + "%" }} />
}
                        </div>
                        {TotalPoints.reduce((partialSum, a) => partialSum + a, 0)*2 > 75 ? 
                        <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedUnderText' style={{marginBlockStart:"20px"}}>Eres un referente de bienestar. Tus hábitos reflejan un compromiso sólido con tu salud y pueden inspirar a otros. Mantén este equilibrio y busca nuevas maneras de perfeccionar tu estilo de vida.</div>
                        : TotalPoints.reduce((partialSum, a) => partialSum + a, 0)*2 > 50 ? 
                        <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedUnderText' style={{marginBlockStart:"20px"}}>Has comenzado a implementar hábitos saludables, pero todavía hay aspectos clave que necesitan atención. Este es el momento de reforzar tus esfuerzos y comprometerte con un cambio más profundo.</div>
                        :
                        <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedUnderText' style={{marginBlockStart:"20px"}}>Tus hábitos actuales pueden estar afectando seriamente tu salud y bienestar. Es importante tomar acción inmediata para evitar problemas mayores. Pequeños cambios hoy pueden prevenir complicaciones mañana.</div>
}
                        <div className='UserWelcomeBlockRadarGraph'>
                            <PolarArea data={GraphData} options={GraphOptions} ></PolarArea>
                        </div>
                        <div className='UserWelcomeResultsCategories'>
                            <h4 className='UserWelcomeBlockResultsCategoriesTitle'>Categorías de Evaluación y su Relevancia</h4>
                            <div className='UserWelcomeBlockResultsCategoriesSubtitle'>No es necesario transformar todos tus hábitos de inmediato. Enfócate en pequeños cambios diarios y sigue nuestras recomendaciones específicas para cada categoría. Recuerda que el cambio gradual y sostenido es la clave para alcanzar un bienestar integral.</div>
                            <div className='UserWelcomeBlockResultsCategoriesTitle2'>Bienestar {TotalPoints[0]}/10</div>
                            {parseInt(TotalPoints[4]) === 10 ? <div className='UserWelcomeBlockResultsCategoriesSubtitle' style={{fontWeight:"700"}}>¡Puntaje perfecto! Lo estás haciendo increíble.</div> : null}
                            <div className='UserWelcomeBlockResultsCategoriesSubtitle'>El bienestar emocional, las relaciones sociales y el propósito personal influyen directamente en tu calidad de vida.</div>
                            <div className='UserWelcomeBlockResultsCategoriesTitle2'>Movimiento {TotalPoints[1]}/10</div>
                            {parseInt(TotalPoints[0]) === 10 ? <div className='UserWelcomeBlockResultsCategoriesSubtitle' style={{fontWeight:"700"}}>¡Puntaje perfecto! Lo estás haciendo increíble.</div> : null}
                            <div className='UserWelcomeBlockResultsCategoriesSubtitle' style={{fontWeight:"700"}}>¡Con solo 30 minutos diarios de caminada haces la diferencia!</div>
                            <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Mantenerte físicamente activo no solo mejora tu salud cardiovascular, sino que también reduce el riesgo de enfermedades crónicas, fortalece los músculos y mejora tu estado de ánimo.</div>
                            <div className='UserWelcomeBlockResultsCategoriesTitle2'>Nutrición {TotalPoints[2]}/10</div>
                            {parseInt(TotalPoints[3]) === 10 ? <div className='UserWelcomeBlockResultsCategoriesSubtitle' style={{fontWeight:"700"}}>¡Puntaje perfecto! Lo estás haciendo increíble.</div> : null}
                            {parseInt(MCAnswers[6]) < 2 ? <div className='UserWelcomeBlockResultsCategoriesSubtitle' style={{fontWeight:"700"}}>Se recomienda comer al menos dos porciones de fruta al día.</div> : null}
                            <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Una alimentación equilibrada es la base para mantener un cuerpo fuerte, un sistema inmunológico resistente y una mente clara.</div>
                            <div className='UserWelcomeBlockResultsCategoriesTitle2'>Recuperación {TotalPoints[3]}/10</div>
                            {parseInt(TotalPoints[1]) === 10 ? <div className='UserWelcomeBlockResultsCategoriesSubtitle' style={{fontWeight:"700"}}>¡Puntaje perfecto! Lo estás haciendo increíble.</div> : null}
                            <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Dormir y manejar el estrés son fundamentales para la regeneración celular, la salud mental y la capacidad de tomar decisiones.</div>
                            <div className='UserWelcomeBlockResultsCategoriesTitle2'>Consumo {TotalPoints[4]}/10</div>
                            {parseInt(TotalPoints[2]) === 10 ? <div className='UserWelcomeBlockResultsCategoriesSubtitle' style={{fontWeight:"700"}}>¡Puntaje perfecto! Lo estás haciendo increíble.</div> : null}
                            <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Lo que bebes o fumas impacta directamente en tus niveles de energía, hidratación y salud metabólica.</div>
                        </div>
                        
                        <h4 className='DiabetesRiskCalculatorResultsNextText'>¡Aquí empieza tu viaje de salud y cuidado preventivo, sigamos adelante!</h4>
                        <div className='UserWelcomeBlockPageWideFlex'>
                            <div className='GeneralWhiteButtonFlex UserWelcomeBlockPageButton2' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/calculadora-de-salud");}}>Terminar</div>
                            <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/plan-de-intervencion");}}>Ir a Recomendaciones</div>
                        </div>
                    
                    </>
                    }
                </div>
            </div>
        </div>
    );
};

export default HabitsCalculator;